export default __webpack_public_path__ + "static/media/SignUp_Title.2bad9ad7.png";